module.exports = __webpack_public_path__ + "img/honer18.a11d7f64.jpg";